import { useMemo } from 'react'
import getBidAmount from 'utils/getBidAmount'

function useBidAmount(item = {}) {
  return useMemo(() => {
    return getBidAmount(item)
  }, [
    item.item_type,
    item.cost,
    item.raffle_price,
    item.high_bid,
    item.reserve,
    item.bid_increment
  ])
}

export default useBidAmount



// WEBPACK FOOTER //
// ./src/hooks/useBidAmount.js